import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { GetOrganisationId } from 'nallian-shared-ui/lib/selectors';

const Owner = ({ value, item, compareId }) => {
  const organisationId = useSelector(GetOrganisationId);
  if (organisationId === item[compareId]) {
    return (
      <span>
        <i>{value}</i>
      </span>
    );
  }

  return <span>{value}</span>;
};

Owner.propTypes = {
  value: PropTypes.string.isRequired,
  item: PropTypes.object.isRequired,
  compareId: PropTypes.string.isRequired,
};

export default Owner;
